module.exports = __webpack_public_path__ + "media/images/iconBell__accent--dark-9f130a588a3dd85ef0b24a859ed2a5bf.png";